module.exports = __webpack_public_path__ + "media/application/images/ui/icon-footer-about-f5edc492828346fc264593b109ff20ed.png";